<template>
  <b-modal
    ref="modal-contact"
    id="single-contact-modal"
    hide-header
	size="lg"
    hide-footer
  >
    <b-row>
      <b-col lg="6">
        <b-card class="h-100">
          <b-card-title>{{$t('contact.needHelp')}}</b-card-title>
          <hr>
          <b-card-text class="block-contact mt-3">
            <h4 class="title-contact mb-0 purple">Allan Barajas</h4>
            <p class="text-muted">Senior Sales Manager</p>

            <p class="mb-0 gray"><md-icon icon="phone"/> +52 998 293 2657</p>
            <p class="mb-0 gray"><md-icon icon="alternate_email"/> allan@shuttlecentral.com</p>
            <p class="mb-0 gray"><md-icon icon="language"/> www.shuttlecentral.com</p>
          </b-card-text>
          <a :href="'https://wa.me/529982932657?text=' + $t('contact.defaultMsj1') + this.$root.store.state.currentUser.firstName + ' ' + this.$root.store.state.currentUser.lastName + $t('contact.defaultMsj2') + this.$root.store.state.currentSystem.system.code + $t('contact.defaultMsj3')" target="_blank" class="btn btn-sm btn-outline-success">{{$t('contact.sendWhats')}}</a>
        </b-card>
      </b-col>
      <b-col lg="6">
        <b-card class="h-100">
          <b-card-title>{{$t('contact.editBooking')}}</b-card-title>
          <hr>
          <b-card-text>
            <p class="text-muted">{{$t('contact.openChatDesc')}}</p>
          </b-card-text>
          <b-button variant="outline-primary" @click="openChat" size="sm">{{$t('contact.openChat')}}</b-button>
        </b-card>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import chatProvider from "@/components/helpers/helpers-chat";
export default {
  components: {},
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    loadModel() {
      this.$refs["modal-contact"].show();
    },
    openChat(){
chatProvider.openChat()
    }
  },
  mounted() {},
};
</script>

<style scoped>
.block-contact h4{
  font-weight: 500;
  font-size: 20px !important;
}

.block-contact .material-icons {
  font-size: 18px !important;
}
.block-contact .purple {
  color: #4f39cf !important;
}
.block-contact .gray {
  color: #55535c !important;
}
</style>



















